import { jsx as _jsx } from "react/jsx-runtime";
import { ListGroup } from "banafo-design-system";
import NewsItem from "src/features/news/NewsItem";
import './NewsList.scss';
const NewsList = ({ news }) => {
    return (_jsx(ListGroup, { as: "ul", variant: "flush", className: "news", children: news.map((newsItem) => _jsx(NewsItem, { newsItem: newsItem }, newsItem.id)) }));
};
export default NewsList;
